import styled from '@emotion/styled';

const NotificationWrapper = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${({ theme }) =>
    theme.tokens.color.alias.cm.bg['bg-accent-inverted'].value};
  border-radius: 50%;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) =>
      theme.tokens.color.alias.cm.bg['bg-accent-inverted'].value};
    border-radius: 50%;
    opacity: 0.6;
    animation: pulse 2s infinite;
  }

  &::before {
    animation-delay: 0.5s;
  }

  &::after {
    animation-delay: 1s;
  }

  @keyframes pulse {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.6;
    }
    100% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
  }
`;

export function NotificationDotComponent(): JSX.Element {
  return <NotificationWrapper />;
}
